export default __webpack_public_path__ + "static/media/algo_visualizer.a65485ad.PNG";